const ENV_DEVELOPMENT = process.env.NODE_ENV === 'development'

// 图片前缀
export const COSPATH = 'http://athena-1255600302.cosgz.myqcloud.com'

// 接口地址
export const APIPATH = ENV_DEVELOPMENT ? '' : location.origin + location.pathname.match(/\/\w+/g)[0]

// 全局跳转
export const ROOTPATH = ENV_DEVELOPMENT ? '' : location.origin + location.pathname.match(/\/\w+/g)[0]



// WEBPACK FOOTER //
// ./src/config/index.js